import appConfig from "../config/app-config";

const LOG_LEVEL = appConfig.logLevel;

/* eslint-disable @typescript-eslint/no-explicit-any */
function logger () { 
    return {
        
        error: (...args: any[]) => {
            if(['info', 'debug', 'warn', 'error'].includes(LOG_LEVEL)) {    
                console.error('[ERROR]', ...args);
            }
        },

        warn: (...args: any[]) => {
            if(['info', 'debug', 'warn'].includes(LOG_LEVEL)) {  
                console.warn('[WARN]', ...args);
            }
        },

        info: (...args: any[]) => {
            if (['info', 'debug'].includes(LOG_LEVEL)) {
                console.log('[INFO]', ...args);
            }
        },

        debug: (...args: any[]) => {
            if(['debug'].includes(LOG_LEVEL)) {    
                console.debug('[DEBUG]', ...args);
            }
        }

    }
}

export default logger();
